{
  "signInRecovery": {
    "title": "Sign-in interrupted",
    "processing": "Completing sign-in…",
    "message": "We could not complete this sign-in. Please sign in again to continue.",
    "action": "Sign in again",
    "starting": "Starting sign-in…",
    "restartFailed": "We could not start sign-in. Check that your browser allows site storage, then try again."
  },
  "loading": "Loading...",
  "save": "Save",
  "cancel": "Cancel",
  "delete": "Delete",
  "search": "Search",
  "close": "Close",
  "confirm": "Confirm",
  "yes": "Yes",
  "no": "No",
  "error": "Error",
  "success": "Success",
  "retry": "Retry",
  "upload": "Upload",
  "download": "Download",
  "logout": "Logout",
  "back": "Go Back",
  "redirectingToLogin": "Redirecting to login...",
  "profile": "Profile",
  "settings": "Settings",
  "user": "User",
  "unnamedPerson": "Name not recorded",
  "language": "Language",
  "selectLanguage": "Select your language",
  "appSwitcher": {
    "selectApp": "Select App",
    "title": "Applications",
    "description": "Switch between Agion applications",
    "tooltip": "Switch application",
    "admin": "Admin",
    "control": "Control",
    "app": "App",
    "analytics": "Analytics"
  },
  "adminDashboard": "Admin Dashboard",
  "profileSettings": "Profile & Settings",
  "uploadFiles": "Upload Files",
  "uploadingFiles": "Uploading files...",
  "pleaseWait": "Please wait",
  "dropFilesHere": "Drop files here",
  "dropFilesOrClick": "Drop files or click",
  "fileTypes": "Excel, CSV, JSON up to {{size}}MB",
  "status": {
    "active": "Active",
    "busy": "Busy",
    "offline": "Offline",
    "pending": "Pending",
    "uploading": "Uploading",
    "processing": "Processing",
    "completed": "Completed",
    "error": "Error",
    "uploaded": "Uploaded",
    "processed": "Processed"
  },
  "roles": {
    "owner": "Owner",
    "admin": "Admin",
    "manager": "Manager",
    "user": "User",
    "auditor": "Auditor"
  },
  "you": "You",
  "agent": "Agent",
  "manager": "Manager",
  "agents": {
    "system": {
      "assistant": "Agion Assistant"
    }
  },
  "hitl": {
    "expired": "This request has expired.",
    "timeout": "Expires in {{time}}",
    "placeholder": "Type your response...",
    "governanceRule": "Governance rule: {{rule}}",
    "operatorHandoff": {
      "title": "Agent needs operator help",
      "description": "The agent cannot resolve this and is requesting human assistance"
    },
    "policyReview": {
      "title": "Governance review required",
      "description": "A governance policy requires human review before proceeding",
      "approve": "Approve",
      "deny": "Deny",
      "decideElsewhere": "This approval is decided in Escalations.",
      "openEscalations": "Decide in Escalations"
    }
  },
  "nextShell": {
    "sidebar": "Chat navigation",
    "missionsNavigation": "Missions",
    "expandSidebar": "Expand sidebar",
    "collapseSidebar": "Collapse sidebar",
    "resizeSidebar": "Resize sidebar",
    "openNavigation": "Open navigation",
    "closeNavigation": "Close navigation",
    "organization": "Organization",
    "files": "Files",
    "running": "Running",
    "theme": {
      "currentLight": "Light mode",
      "currentDark": "Dark mode",
      "switchToLight": "Switch to light mode",
      "switchToDark": "Switch to dark mode"
    },
    "appSwitcher": {
      "chat": "Chat",
      "switchApp": "Switch app",
      "currentApp": "Current app",
      "open": "Open"
    },
    "missionsLoadError": "Missions could not be loaded"
  },
  "nextFailure": {
    "hostUnknown": "The Edge host that ran this mission is not recorded, so its conversation cannot be found.",
    "network": "The connection to Agion failed. Check your network and try again.",
    "unavailable": "The service is not responding right now. Try again in a moment.",
    "session": "Your session has ended. Sign in again to continue.",
    "forbidden": "Your role does not allow this.",
    "missing": "It no longer exists or has moved.",
    "refused": "The request was refused.",
    "unknown": "Something went wrong. Try again.",
    "hostOfflineNamed": "{{name}}, the Edge host that holds this conversation, is offline. Try again when it is back.",
    "hostOffline": "The Edge host that holds this conversation is offline. Try again when it is back."
  }
}
